






























import { Component, Vue } from "vue-property-decorator";
import { EventBus } from "../../event-bus";
import axios from "axios";
import ChangePasswordPart from "@/pages/users/ChangePasswordPart.vue";
import BaseFormEdit from '../../models/base.form.edit';

@Component({ components: { 'change-password-part': ChangePasswordPart } })
export default class ChangePassword extends BaseFormEdit {
  form = { password: '', confirmPassword: '' };

  created() {
    document.title = this.$t('SCDB') + " | " + this.$t('Изменение пароля');
  }

  protected onFetchDataError() {
    this.$router.push('/login');
  }

  private handleSubmit() {
    EventBus.$emit("showThrobber");
    axios.post('/changePassword', this.form)
         .then(response => {
            EventBus.$emit('success', { msg: response.data });
            EventBus.$emit("hideThrobber");
            this.$router.push('/login');
         })
         .catch(error => {
            EventBus.$emit("hideThrobber");
            EventBus.$emit("error", { msg: error.data });
          });;
  }
}
